import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { routeConfig } from './config'
import { ErrorBoundary } from 'src/components'
import { NotAuthorized, InternalServerError } from './Error'
import { ContentRoute } from './ContentRoute'
import MfaContext from 'src/components/MfaContext'
import axios from 'axios'

class Main extends React.Component {
    state = {
        params: {},
        sessionToken: '',
        loading: false,
    }

    componentDidMount() {
        let params = {}
        if (this.props.location.search) {
            const searchParams = new URLSearchParams(this.props.location.search)
            for (const [key, value] of searchParams) {
                params[key] = value
            }
        }
        this.setState({
            params: params,
        })
        if (params.signature) {
            this.getSessionToken(params.signature)
        }
    }

    getSessionToken = async signature => {
        try {
            this.setState({ loading: true })
            let response = await axios({
                url: '/api/mfa/sessions',
                headers: {
                    Authorization: `Bearer ${signature}`,
                },
                method: 'POST',
            })
            this.setState({
                params: {
                    sessionToken: response.headers.authorization,
                    ...this.state.params,
                },
                loading: false,
            })
        } catch (error) {
            this.setState({ loading: false })
        }
    }

    render() {
        return (
            <>
                {/*this needs to be outside because we redirect to it from the ErrorBoundary*/}
                <Route
                    exact
                    path={'/internal-error'}
                    component={InternalServerError}
                />
                <Route>
                    <ErrorBoundary>
                        <MfaContext.Provider value={this.state.params}>
                            <Switch>
                                {routeConfig.map((route, index) => {
                                    if (
                                        route.paramsExistence instanceof
                                        Function
                                    ) {
                                        if (
                                            !route.paramsExistence(
                                                this.state.params
                                            )
                                        ) {
                                            return null
                                        }
                                    }
                                    return (
                                        <ContentRoute
                                            key={index}
                                            match={this.props.match}
                                            path={route.path}
                                            component={route.component}
                                            title={route.title}
                                            name={route.name}
                                        />
                                    )
                                })}
                                {!this.state.loading ? (
                                    <Route component={NotAuthorized} />
                                ) : null}
                            </Switch>
                        </MfaContext.Provider>
                    </ErrorBoundary>
                </Route>
            </>
        )
    }
}

export default Main
